(function(angular) {
    'use strict';

    angular.module('aprima-provider-api').factory('ListService', [
        '_',
        '$q',
        'AprimaAnalytics',
        'AprimaCache',
        'ListMedicationRepository',
        'ListRepository',
        'RequestTypes',
        ListService
    ]);

    function ListService(
        _,
        $q,
        AprimaAnalytics,
        AprimaCache,
        ListMedicationRepository,
        ListRepository,
        RequestTypes
    ) {

        var medicationsListTypeRegex = /^medications-/i;
        var defaultCache = AprimaCache.Lists.httpMode;

        var service = {
            getList: getList,
            getLists: getLists,
        };

        return service;

        // listType can be
        // string: 'listName'
        // or
        // object: { name: 'listName', params: { query: 'something'}}
        function getList(listType, $scope, scopeProperty, applicationComponent) {
            var queryListType = listType && listType.name || listType;
            var listParams = listType && listType.params;
            var promise;
            var timing = AprimaAnalytics.startTiming(applicationComponent || 'ListService', 'api', 'getList-' + queryListType);

            var repo = ListRepository;

            if(medicationsListTypeRegex.test(queryListType)) {
                repo = ListMedicationRepository;
                queryListType = queryListType.replace(medicationsListTypeRegex, '');
            }

            promise = repo.getList(queryListType, listParams, defaultCache)
                .then(function (list) {
                    var plainList = list && list.plain ? list.plain() : list;

                    return plainList;
                }, function(response) {
                    response.listType = queryListType.split('/')[0];
                    return $q.reject(response);
                });

            if($scope && scopeProperty) {
                promise = promise.then(function(list){
                    $scope[scopeProperty] = list;
                    return list;
                });
            }

            return promise.finally(timing.stop);
        }

        //==============================================================================
        //Structure of lists as an Object:
        // {scopeProperty1: 'listType1', scopeProperty2: 'listType2', scopeProperty3: 'listType3'}
        //Returns promise that resolves to
        // {scopeProperty1: [list1], scopeProperty2: [list2], scopeProperty3: [list3]}
        //==============================================================================
        //Structure of lists as an Array:
        // ['listType1', 'listType2', 'listType3']
        //Returns promise that resolves to
        // [[list1], [list2], [list3]]
        function getLists(lists, $scope, applicationComponent) {
            var mappingFn = _.isArray(lists) ? _.map : _.mapValues;

            var listPromises = mappingFn(lists, function(listType, scopeProperty) {
                return getList(listType, $scope, scopeProperty, applicationComponent);
            });

            var allPromises = $q.all(listPromises);

            if($scope) {
                allPromises = allPromises
                    .then(function(data) {
                        $scope.removeHttpError(RequestTypes.listData);
                        return data;
                    }, function(response) {
                        var message = {};
                        message['is' + response.status] = response.listType;
                        $scope.addHttpError(response, message, RequestTypes.listData);
                        return $q.reject(response);
                    });
            }

            return allPromises;
        }
    }

})(window.angular);
